import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import queryString from "query-string";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import TabPanel from "../../elements/tab/materialTabPanel";
// import BinDataContainer from "./binData/BinDataContainer";
import ServiceExclusionContainer from "./serviceExclusion/ServiceExclusionContainer";
import ServiceExclusionContainerNew from "./serviceExclusionNew/ServiceExclusionContainer";

import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBinDataWrapper } from "../styledBinData";

// const DEFAULT_TAB = "binData";
const DEFAULT_TAB = "serviceExclusions";

const BinsContainer = ({ match }) => {
  const { t } = useTranslation("binData");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 1;
    }

    switch (queryParams.currentTab) {
      // case "binData": {
      //   return 0;
      // }
      case "serviceExclusions": {
        return 1;
      }
      case "serviceExclusionsNew": {
        return 2;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledContentWrapper>
        <StyledBinDataWrapper>
          <StyledTabsHead
            className="tab-head"
            orientation="horizontal"
          >
            <Tabs
              value={queryParams?.currentTab ?? DEFAULT_TAB}
              indicatorColor="secondary"
              onChange={handleChange}
              orientation="horizontal"
              className="tab-head-buttons"
              variant="scrollable"
              scrollButtons="auto"
            >
              {/*<Tab label={t("tabs.binData")} value="binData" />*/}
              <Tab label={t("tabs.serviceExclusions")} value="serviceExclusions" />
              <Tab label={t("tabs.serviceExclusions") + " (NEW)"} value="serviceExclusionsNew" />
            </Tabs>
          </StyledTabsHead>
          <StyledTabsBody className="tab-body">
            {/*<TabPanel
              value={tabValue}
              index={0}
            >
              <BinDataContainer match={match} t={t} />
            </TabPanel>*/}
            <TabPanel
              value={tabValue}
              index={1}
            >
              <ServiceExclusionContainer match={match} t={t} />
            </TabPanel>
            <TabPanel
              value={tabValue}
              index={2}
            >
              <ServiceExclusionContainerNew match={match} t={t} />
            </TabPanel>
          </StyledTabsBody>
        </StyledBinDataWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default BinsContainer;